function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 0L0 7.2h2.182v6.546h11.637V7.2H16L8 0zm0 1.957l4.364 3.928v6.406H3.637V5.885L8 1.957zM5.09 10.11V7.928h2.183v2.181H5.09z",
  fill: "#BB5366"
});

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    fill: "none"
  }, props), _ref);
}

export default SvgHome;